import React from "react";
import { makeStyles, useTheme, SvgIconProps, SvgIcon } from "@material-ui/core";
import MaterialCloseIcon from "@material-ui/icons/Close";
import { Theme } from "../.themes";

const useStyles = makeStyles(() => ({
  default: {
    cursor: "pointer",
  },
}));

export const CloseIconButton: React.FC<SvgIconProps> = (props: SvgIconProps) => {
  const theme: Theme = useTheme();
  const css = useStyles();

  const cname = [css.default, props.className].join(" ");
  const element = (theme.icons?.crossIcon && (
    <SvgIcon {...props} className={cname}>
      {theme.icons?.closeIcon ?? theme.icons?.crossIcon}
    </SvgIcon>
  )) ?? <MaterialCloseIcon {...props} className={cname} />;
  return element;
};

export default CloseIconButton;
